import React, { useState, useEffect } from 'react'
import PATTERN from 'assets/images/bostfactory-pattern.svg'
import { useForm } from "react-hook-form";
import AuthService from 'api/services/AuthService'
import { Redirect } from 'react-router-dom'
import Input from 'components/forms/Input';
import InputPassword from 'components/forms/Input_';

import { useTranslation } from 'react-i18next';
import axiosAuthClient from 'api/shared/AxiosAuthClient';
import {FiLock, FiUnlock} from 'react-icons/fi'
import PropTypes from 'prop-types';

export default function SignIn(props) {

	const { t } = useTranslation();
	const { register, handleSubmit, formState: { errors } } = useForm();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [authorised, setAuthorised] = useState(false);
	const [showPassword, setShowPassword] = useState(false)


	const onLogin = async (credentials) => {
		if (credentials) {
			setError(null)
			setLoading(true)
			setTimeout(async () => {
				try {
					const resp = await axiosAuthClient.post(`/auth/login`, credentials);
					if (resp?.data) {
						AuthService.saveSession(resp.data)
						setLoading(false)
						// history.go()
						setAuthorised(true)
					}
				} catch (error) {
					if (error.response) {
						setError(error.response?.data?.message)
					} else {
						setError("ERR_OOPS")
					}
					setLoading(false)
					setAuthorised(false)
				}
			}
				, 1000);
		}
	}


	async function checkAutorization(params) {
		let a = AuthService.isValidSession()
		// Check Token Validity 
		if (a) {
			setAuthorised(true)
		} else {
			setAuthorised(false)
		}
	}

	useEffect(() => {
		checkAutorization()
	}, [authorised])


	if (authorised) {
		return <><Redirect to='/' /> </>
	}
	else {
		return (

			<div className="absolute w-full h-full ">
				<div className='absolute shadow-md top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex border p-2 bg-white rounded  w-fit '>
					<div className="hidden border lg:block sm:w-[480px] bg-cover bg-gray-800 rounded" >
						<img src={PATTERN} alt='' className='m-8 ' />
					</div>

					<div className="w-[560px] lg:w-[480px]  rounded">
						<div className=" flex flex-col min-w-0 break-words  mb-6  rounded-lg  border-0 p-8">
							<div className='font-bold text-xl text-gray-800'>Sign In to{' '}<span className='px-2 text-blue-500 '>{t('project_name')}{' '}<sub>platform</sub></span></div>
							<div className='mt-4'>
								{ }<HandleAuthResponse error={error} />
							</div>
							<form className="w-full mt-4  first-letter:space-y-6" method="POST" onSubmit={handleSubmit(onLogin)}>
								<Input
									className="my-4"
									id="email"
									type="email"
									label={t('form.email')}
									placeholder="user.admin@campany.com"
									register={register("email", {
										required: t('form.missing_field')
									})}
									error={errors?.email}
								/>
								{/* <Input
									className="my-4"
									id="password"
									type="password"
									label={t('form.password')}
									placeholder="*******"
									register={register("password", {
										required: t('form.missing_field')
									})}
									error={errors?.password}

								/> */}

								<InputPassword
									required
									className='my-2'
									label={t('form.password')}
									id={"password"}
									placeholder={t('form.hint_password')}
									type={showPassword ? 'text' : 'password'}
									autoComplete='password'
									register={register("password", {
										required: t('form.missing_field')
									})}
									error={errors.password}
									suffix={<button type="button" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <FiUnlock /> : <FiLock />}</button>}
								/>


								<button type="submit"
									className="my-4 rounded w-full px-4 py-2 text-base flex items-center justify-center font-semibold text-center text-white transition duration-200 ease-in bg-blue-500 shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 " >
									{
										loading ?
											<svg width="20" height="20" fill="currentColor" className="mr-2 animate-spin" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
												<path d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z">
												</path>
											</svg>
											: 'Sign In'}
								</button>

							</form>

							<div className='mt-8 flex justify-center bottom-0'>
								<PoweredBy />
							</div>
						</div>
					</div>

				</div>



			</div>
		)
	}
}



function PoweredBy() {
	return (
		<div className='text-sm text-gray-400  px-2'>
			<span className='text-xs'>Powered by</span> <span className='text-blue-500 font-bold'> BotsFactory</span>
		</div>
	)
}


function HandleAuthResponse(props) {
	const { t } = useTranslation();

	return (
		<>
			{props?.error &&
				<div className=" bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded" role="alert">
					{/* <p className="font-bold">{t('warning.reached')}</p> */}
					<p className="text-sm font-medium">
						{props?.error === 'ERR_OOPS' ? t('errors.oops_title') + ".\n" + t('errors.oops_subtitle') + "." : props?.error}
					</p>
				</div>}
		</>
	);
}

HandleAuthResponse.propTypes = {
  error: PropTypes.string,
};
